import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon/FnrIcon";

const color = ({
  $active,
  $disabled,
  $dark,
  $flat,
  theme: {
    colors: {
      divider,
      lightGray,
      textPrimary,
      fnWhite,
      textLight,
      textSecondary,
      fnGrey,
    },
  },
}) => {
  let returnColor;
  if ($disabled) returnColor = $dark ? lightGray : divider;
  // active flat needs a more suble shades of blue for standard themes.
  else if ($flat && $active) returnColor = $dark ? textLight : divider;
  else if ($active) returnColor = $dark ? textLight : textPrimary;
  // inactive flat needs a more suble shades of grey for standard themes.
  else if ($flat) returnColor = $dark ? fnWhite : fnGrey;
  else returnColor = $dark ? fnWhite : textSecondary;
  return `color: ${returnColor};`;
};

const rotations = ["0deg", "90deg", "180deg", "270deg"];

const rotation = ({ $active, $flat, $sideways, $backwards }) => {
  let rotationOffset = 0;
  if ($sideways) rotationOffset += 1;
  if ($backwards) rotationOffset += 2;
  const activeRotation = rotations[(2 + rotationOffset) % 4];
  const inactiveRotation = rotations[rotationOffset % 4];
  const flatRotation = inactiveRotation; // additional variable for clarity.

  if ($flat)
    return `transform: scaleX(1.25) scaleY(${
      $active ? "-" : ""
    }.5) rotate(${flatRotation});`;
  return `transform: rotate(${$active ? activeRotation : inactiveRotation});`;
};

const transition = ({ $flat }) => {
  return `
   transition: color 0.5s, transform ${$flat ? ".5s" : "0.25s"};
  `;
};

const fontSize = ({ $flat }) => {
  return `font-size: ${$flat ? "24px" : "16px"};`;
};

const SDiv = styled("div")`
  ${rotation}
  ${color}
  ${fontSize}
  ${transition}
  display: inline-block;
`;

const FnrChevron = ({
  active,
  disabled,
  dark,
  flat,
  sideways,
  backwards,
  ...rest
}) => (
  <SDiv
    $active={active}
    $disabled={disabled}
    $flat={flat}
    $dark={dark}
    $sideways={sideways}
    $backwards={backwards}
    data-cy="FnrChevron_Container"
    {...rest}
  >
    <FnrIcon icon="chevron-down far" />
  </SDiv>
);

FnrChevron.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  dark: PropTypes.bool,
  flat: PropTypes.bool,
  sideways: PropTypes.bool,
  backwards: PropTypes.bool,
};

export default FnrChevron;
